/* ==========================================================================
  main.js
========================================================================== */

"use strict";
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});
